import ReactPaginate from "react-paginate";
const Pagination = ({
  pageCount = 10,
  onPageChange,
  itemsPerPage,
  totalItems = 100,
  currentPage,
}) => {
  return (
    <div className="cstmPagination d-flex align-items-center flex-wrap justify-content-end gap-10">
      <div className="right d-flex align-items-center gap-10">
        <ReactPaginate
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={onPageChange}
          forcePage={currentPage - 1}
          containerClassName="pagination"
          activeClassName="active"
          previousLabel={
            <span className="pagination-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M15.5 18L9.5 12L15.5 6"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          }
          nextLabel={
            <span className="pagination-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M8.5 6L14.5 12L8.5 18"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          }
          breakLabel="..."
          breakClassName="break-me"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          nextClassName="page-item"
          previousLinkClassName="page-link"
          nextLinkClassName="page-link"
          disabledClassName="disabled"
        />
      </div>
    </div>
  );
};
export default Pagination;
